// extracted by mini-css-extract-plugin
export var artArchiveImage = "ArtArchiveSection-module--art-archive-image--p7EQI";
export var artArchiveLink = "ArtArchiveSection-module--art-archive-link--BrO-v";
export var artArchiveSection = "ArtArchiveSection-module--art-archive-section--zp7AR";
export var artArchvieSection = "ArtArchiveSection-module--art-archvie-section--zHI8A";
export var titleWrap = "ArtArchiveSection-module--title-wrap--VQ5W4";